module.exports = __webpack_public_path__ + "static/media/bread-brunch-lunch.1d35a31a.jpg";